import { TeamService } from '@/services/team.service'
import { queryOptions } from '@tanstack/react-query'

export const listTeamsQuery = queryOptions({
  queryKey: ['list-teams'],
  queryFn: TeamService.getTeams,
})

export const teamPermissionsQuery = queryOptions({
  queryKey: ['team-permissions'],
  queryFn: TeamService.getPermissions,
  staleTime: 1000 * 60 * 5,
  retry: false,
})

export const teamPermissionsConfigQuery = queryOptions({
  queryKey: ['team-permissions-config'],
  queryFn: TeamService.getAttendantPermissionsConfig,
  staleTime: 1000 * 60 * 5,
})
